import { render, staticRenderFns } from "./cdmpending.vue?vue&type=template&id=57e21c29&"
import script from "./cdmpending.vue?vue&type=script&lang=js&"
export * from "./cdmpending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports